import React from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';

import styles from './styles';
import { doesArrayHasLength } from '../../utils/isDefined';
import { translate } from '../../i18n/I18nProvider';
import withSettings from '../../utils/withSettings';

const ActivationResultSummary = ({ classes, settings, results = [] }) => {
  const succeededUsers = results
    .filter(result => result.isSuccess)
    .map(result => result.username)
    .join(', ');
  const failedResults = results.filter(result => !result.isSuccess);

  return (
    <div className={classes.summary}>
      {succeededUsers.length > 0 && (
        <div className={classes.summaryRow}>
          <div style={{ color: settings.colors.success }}>
            {translate('MESSAGE.ACTIVATION_MESSAGE_SEND_SUCCESS_TO')}:
          </div>
          <div style={{ color: settings.colors.success }}>{succeededUsers}</div>
        </div>
      )}
      {failedResults.length > 0 && (
        <div style={{ color: settings.colors.danger }}>
          {translate('MESSAGE.ACTIVATION_MESSAGE_SEND_FAILURE_TO')}:
        </div>
      )}
      {failedResults.map((result, i) => (
        <div className={classes.summaryRow} key={i}>
          <div style={{ color: settings.colors.danger }}>{result.username}</div>
          {doesArrayHasLength(result.devices) && (
            <div className={classes.summaryErrors}>
              {result.devices.map((device, idx) => (
                <div key={idx}>
                  {device.deviceType}:{' '}
                  <span
                    style={{
                      color: device.isSuccess
                        ? settings.colors.success
                        : settings.colors.danger
                    }}
                  >
                    {device.isSuccess
                      ? translate('SUCCESS')
                      : doesArrayHasLength(device.reasons)
                      ? device.reasons.join(', ')
                      : translate('FAILURE')}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default flowRight(
  withSettings,
  withStyles(styles)
)(ActivationResultSummary);
